import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash-v2-smart-results',
    templateUrl: 'bulk-infohash-v2-smart-results.component.html',
    styleUrls: ['bulk-infohash-v2-smart-results.component.scss']
})
export class BulkInfohashV2SmartResultsComponent {
    @Input() results = [];
    @Input() checkboxesEnabled = true;

    @Output() onHandleOpen = new EventEmitter();

    constructor() {
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        this.onHandleOpen.emit(result);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }
}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-smart-results/bulk-infohash-v2-smart-results.component.ts